import { SearchableSelect } from "@/components/shared/SearchableSelect";
import { Input } from "@/components/ui/input";

export const todayLocal = () => new Date().toLocaleDateString("en-CA");

export function HoManualEntryFields({ prefix, sites, site, onSite, date, onDate, kinds, kind, onKind }) {
  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50/60 p-3 space-y-3" data-testid={`${prefix}-ho-fields`}>
      <p className="text-xs font-semibold text-amber-800">Head Office entry on behalf of a site</p>
      <div className="flex gap-1.5">
        {kinds.map((k) => (
          <button
            key={k.key}
            type="button"
            data-testid={`${prefix}-ho-kind-${k.key}`}
            onClick={() => onKind(k.key)}
            className={`rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${
              kind === k.key ? "bg-amber-600 text-white" : "bg-white text-slate-600 border border-slate-200 hover:bg-slate-100"
            }`}
          >
            {k.label}
          </button>
        ))}
      </div>
      <div>
        <p className="text-sm font-medium text-slate-700 mb-1.5">Site *</p>
        <SearchableSelect
          testId={`${prefix}-ho-site-select`}
          value={site}
          onValueChange={onSite}
          placeholder="Select site"
          options={sites.map((s) => ({ value: s.code, label: s.display_label || s.label, testId: `${prefix}-ho-site-option-${s.code}` }))}
        />
      </div>
      <div>
        <p className="text-sm font-medium text-slate-700 mb-1.5">Entry Date *</p>
        <Input type="date" max={todayLocal()} data-testid={`${prefix}-ho-date-input`} value={date} onChange={(e) => onDate(e.target.value)} />
      </div>
    </div>
  );
}

export function HoEntryTag() {
  return (
    <span data-testid="ho-entry-tag" className="ml-1.5 rounded bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold text-amber-800 align-middle">
      HO entry
    </span>
  );
}
